import { render, staticRenderFns } from "./DeviceOwnership.vue?vue&type=template&id=c241c5fe&"
import script from "./DeviceOwnership.vue?vue&type=script&lang=js&"
export * from "./DeviceOwnership.vue?vue&type=script&lang=js&"
import style0 from "./DeviceOwnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c241c5fe')) {
      api.createRecord('c241c5fe', component.options)
    } else {
      api.reload('c241c5fe', component.options)
    }
    module.hot.accept("./DeviceOwnership.vue?vue&type=template&id=c241c5fe&", function () {
      api.rerender('c241c5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/DeviceOwnership.vue"
export default component.exports